<template>
  <div class="page-container content-430">
    <div class="baseinfo-box">
      <div class="baseinfo-header">
        <div class="base-left">
          <span class="base-name">{{ baseInfo.classroomName }}</span>
          <span>（课时：{{ baseInfo.classroomTotal }}）</span>
          <span>（学生姓名：{{ studentName }}）</span>
        </div>
      </div>
    </div>
    <!-- 搜索模块 -->
    <SearchBlock
      :student-attance-details="true"
      @getSearchValue="handleGetSearch"
    ></SearchBlock>
    <div class="table-title-special-430">
      <div class="box-title-430"></div>
      <div class="operation-430">
        <Button
          class="search-430"
          type="primary"
          @click="handleOpenOperationModal"
        >操作记录</Button>
        <Button
          class="search-430"
          type="primary"
          @click="handleExSubmit"
        >导出Excel</Button>
      </div>
    </div>
    <!-- 表格内容 -->
    <div class="table askleave-table">
      <Table
        border
        stripe
        max-height="485"
        :columns="askLeaveColumn"
        :loading="loadingAttendanceDetailsData"
        :data="attendanceDetailsData"
      >
        <template slot="classroomName" slot-scope="{ row }">
          <span v-if="row.classroomId">{{ row.classroomName }}</span>
          <span v-else>--</span>
        </template>
        <template slot="spellClassTime" slot-scope="{ row }">
          <span v-if="row.classroomId">{{ row.spellClassTime }}（第{{ row.classNo }}节）</span>
          <span v-else>--</span>
        </template>
        <template slot="courseDetailState" slot-scope="{ row }">
          <span>{{
            row.courseDetailState
              ? courseDetailObj[row.courseDetailState]
              : '--'
          }}</span>
        </template>
        <template slot="signState" slot-scope="{ row }">
          <!-- <span v-if="row.classroomId">{{ row.signState === 4 ? '请假' : signStatusObj[row.signState]
          }}{{
            row.tallySts === 5 && row.signState !== 4 ? '（已退款）' : ''
          }}</span> -->
          <span v-if="row.classroomId">{{ row.signState === 4 ? '请假' : signStatusObj[row.signState]
          }}{{
            row | showHasRefundText
          }}</span>
          <span v-else>--</span>
          <span v-if="row.daycareDetailId&&row.daycareDetailId!=='0'" style="color:red">（节次已转入其他班级）</span>
        </template>
        <!-- <template slot="action" slot-scope="{ row }">
          <div>
            <span
              v-if="!row.classroomId && studentSts === 1"
              class="click-btn-430"
              @click="handleShowNewModal(row, 'new')"
            >新增</span>
            <span v-else-if="!row.classroomId">--</span>
            <span
              v-else-if="row.isShowEditBtn"
              class="click-btn-430"
              @click="handleEdit(row)"
            >修改</span>
            <span v-else>--</span>
          </div>
        </template> -->
      </Table>
      <Page
        :total="pageInfo.total"
        show-total
        show-sizer
        show-elevator
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <!-- <Modal
      v-model="changeDifferentModalShow"
      :width="500"
      title="设置考勤状态"
      :footer-hide="true"
    >
      <Form
        ref="oldLeaveSubmitForm"
        :rules="oldSubmitInfoRule"
        :model="oldSubmitInfo"
        :label-width="150"
      >
        <FormItem label="班级名称" prop="classroomId">
          <Select
            v-model="oldSubmitInfo.classroomId"
            @on-change="getChangeClassroomId"
          >
            <Option
              v-for="item in listSchStuSignClassNo"
              :key="item.classroomId"
              :value="item.classroomId"
            >{{ item.classroomName }}</Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="
            oldSubmitInfo.classroomId === classroomId &&
              listSchStuSignClassNo[selectClassroomIdIndex].listCourseDefine &&
              listSchStuSignClassNo[selectClassroomIdIndex].listCourseDefine
                .length > 0
          "
          label="考勤节次"
          prop="detailId"
        >
          <Select v-model="oldSubmitInfo.detailId">
            <Option
              v-for="item in listSchStuSignClassNo[selectClassroomIdIndex]
                .listCourseDefine"
              :key="item.detailId"
              :value="item.detailId"
            >{{ item.spellClassTime }}</Option>
          </Select>
        </FormItem>
        <FormItem label="设置考勤状态" prop="changeType">
          <Select v-model="oldSubmitInfo.changeType">
            <Option
              v-for="item in changeSignEnumList"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <div class="page-right">
          <Button
            type="primary"
            :loading="loadingChangeData"
            @click="handleSureEdit"
          >确定</Button>
        </div>
      </Form>
    </Modal> -->
    <!-- <Modal
      v-model="changeSignStatusModalShow"
      :width="500"
      title="设置考勤状态"
      :footer-hide="true"
    >
      <Form ref="leaveSubmitForm" :model="submitInfo" :label-width="150">
        <FormItem label="设置考勤状态" prop="changeType">
          <Select v-model="submitInfo.changeType">
            <Option
              v-for="item in changeSignEnumList"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <div class="page-right">
          <Button
            type="primary"
            :loading="loadingChangeData"
            @click="handleChangeSignStatus"
          >确定</Button>
        </div>
      </Form>
    </Modal> -->
    <!-- 下载的进度弹窗 -->
    <Modal
      v-model="percentModalShow"
      title="正在导出"
      :mask-closable="false"
      @on-cancel="handleCancelDownLoad"
    >
      <Progress :percent="downLoadPersent" :stroke-width="5"></Progress>
      正在导出表格，请给我一些时间，请不要关闭当前页面！
      <div slot="footer">
        <Button @click="handleCancelDownLoad">取消</Button>
      </div>
    </Modal>
    <!-- 操作记录弹窗 -->
    <Modal
      v-model="showOperationRecord"
      :width="1000"
      title="操作记录"
      :footer-hide="true"
    >
      <div class="operation-search">
        <Input
          v-model="operationSearchStr"
          clearable
          placeholder="请输入操作说明关键字检索"
          style="width: 230px"
        ></Input>
        <Button
          type="primary"
          @click="handleSearchOperationRecord"
        >查询</Button>
      </div>
      <div class="operation-list">
        <Table
          border
          stripe
          max-height="600"
          :columns="operationColumn"
          :loading="loadingOperationData"
          :data="operationListData"
        >
          <template slot="actType" slot-scope="{ row }">
            <span>{{ actTypeList[row.actType] }}</span>
          </template>
        </Table>
        <Page
          :total="operationPageInfo.total"
          show-total
          show-elevator
          :current="operationPageInfo.pageNum"
          class="page-right"
          @on-change="handleOperationPageChange"
        ></Page>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  tableColumnsWidth,
  key,
  slot
} from '@/assets/js/resetTableStyle';
import axios from 'axios';
import SearchBlock from '../assets/components/SearchBlock.vue';
import eduCenter from '@/request/eduCenter/index.js';
import { mapGetters, mapMutations } from 'vuex';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import { signStatusList, courseDetailStsEnumList, changeDictionaries, hasRefundTallyStsList } from '@/utils/dictionary.js';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import { isPassExpectTime } from '@/utils/utils.js';
export default {
  name: 'EduCenterStudentAttanceIndexDetails',
  filters: {
    showHasRefundText(row) {
      const tag = hasRefundTallyStsList.includes(row.tallySts);
      return tag && row.signState !== 4 ? '（已退款）' : '';
    }
  },
  components: {
    SearchBlock
  },
  data() {
    return {
      askLeaveColumn: [
        key('序号', 'sort', tableColumnsWidth.type2),
        slot('课程班级名称', 'classroomName', tableColumnsWidth.type6),
        slot('考勤时间（时间）', 'spellClassTime', tableColumnsWidth.type7),
        slot('状态', 'courseDetailState', tableColumnsWidth.type6),
        slot('签到状态', 'signState', tableColumnsWidth.type6), // 0未开始 1未考勤 2签到 3签退 4请假 5缺席 6停课
        key('签到记录人', 'reviewTeaherName', tableColumnsWidth.type6),
        key('请假原因', 'leaveDescribe', tableColumnsWidth.type6)
        // slot('操作', 'action', tableColumnsWidth.action, { fixed: 'right' })
      ],
      loadingAttendanceDetailsData: false, // 是否在加载列表
      attendanceDetailsData: [], // 请假数据
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }, // 请假列表分页信息
      searchData: {}, // 从搜索框组件拿到的搜索入参
      source: null,
      percentModalShow: false, //
      downLoadPersent: 0,
      percentInterVal: null,
      portOrg: -1,
      classroomId: '', // 课班id
      stuId: '', // 学生id
      payOrderId: '', // 订单id
      signStatusObj: changeDictionaries(signStatusList),
      courseDetailObj: changeDictionaries(courseDetailStsEnumList),
      changeSignStatusModalShow: false,
      submitInfo: {
        changeType: -1
      },
      changeSignEnumList: [
        {
          label: '已签到',
          value: 1
        },
        // {
        //   label: '请假',
        //   value: 2
        // },
        {
          label: '未签到',
          value: 3
        }
      ],
      selectRow: {}, // 选择的数据
      baseInfo: {}, // 课班详情
      classTypeList: [
        '-',
        '课程',
        '托管'
      ], // 课程类别,1-课程 2-托管
      showOperationRecord: false, // 是否展示操作记录弹窗
      operationSearchStr: '', // 操作记录要搜索的关键字
      operationColumn: [
        slot('操作类型', 'actType', tableColumnsWidth.type2),
        key('操作人', 'operatorName', tableColumnsWidth.type3),
        key('操作时间', 'operateTime', tableColumnsWidth.type3),
        key('说明', 'remark', tableColumnsWidth.type7) // 0未开始 1未考勤 2签到 3签退 4请假 5缺席 6停课
      ], // 操作记录表头
      actTypeList: ['', '新增', '修改'], // 操作记录  1:新增 2：修改
      loadingOperationData: false, // 是否加载操作记录表
      operationListData: [], // 操作记录表格数据
      operationPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      changeDifferentModalShow: false, // 是否展示以前考勤的弹窗
      oldSubmitInfo: {
        classroomId: '', // 课班id
        detailId: '', //
        changeType: -1,
        signState: -1 // 1未考勤 2已签到 3请假
      }, // 之前在别的班的考勤
      oldSignEnumList: [
        {
          label: '未签到',
          value: 1
        }, {
          label: '请假',
          value: 2
        }, {
          label: '已签到',
          value: 3
        }
      ],
      listSchStuSignClassNo: [], // 查询未上课节次
      selectClassroomIdIndex: 0, // 默认选中的第几个
      selectBtnType: 'edit', // edit new
      studentName: '', // 学生姓名
      loadingChangeData: false, // 是否正在提交接口
      studentSts: -1 // 学生状态  0-离班 1-在读
    };
  },
  computed: {
    ...mapGetters(['theUserIdentity', 'routeTitle']),
    oldSubmitInfoRule() {
      const rule = {
        classroomId: [
          { required: true, message: '请选择课班', trigger: 'change' }
        ],
        changeType: [{ required: true, type: 'number', message: '请选择考勤状态', trigger: 'change' }]
      };
      if (this.oldSubmitInfo.classroomId === this.classroomId) {
        rule.detailId = [{ required: true, message: '请选择考勤节次', trigger: 'change' }];
      }
      return rule;
    }
  },
  created() {
    this.classroomId = this.$route.query.classroomId;
    this.stuId = this.$route.query.stuId;
    this.payOrderId = this.$route.query.payOrderId || '';
    this.studentName = this.$route.query.studentName;
    // 如果接口没有值就用这个
    this.studentSts = this.$route.query.studentSts === undefined ? -1 : (+this.$route.query.studentSts);
  },
  mounted() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.getCourseBaseDetails();
    this.getAttendanceDetailsList();
    // if (this.portOrg !== 2) {
    //   this.getAttendanceDetailsList();
    // }
  },
  methods: {
    // 获取课班详情基础信息
    async getCourseBaseDetails() {
      const params = {
        classroomId: this.classroomId
      };
      const res = await courseSchedulCenter.getClassPartitionDetails(params);
      if (res.status === 200) {
        console.log(res.message.teacherSignRuleBo, '基础信息shisha-');
        this.baseInfo = res.message;
      }
    },
    ...mapMutations(['SET_CACHEROUTE']),
    // 获取学生考勤明细接口
    async getAttendanceDetailsList() {
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        stuId: this.stuId,
        classroomId: this.classroomId,
        payOrderId: this.payOrderId
      };
      const paramsData = Object.assign({}, this.searchData, params);
      try {
        this.loadingAttendanceDetailsData = true;
        const res = await eduCenter.getStudentAttendanceDetailsApi(paramsData);
        if (res.status === 200) {
          this.attendanceDetailsData = res.message.list.map((item, index) => {
            // item.signStateShow = item.signState;
            if ((+item.signState === 0 || +item.signState === 1) && item.classroomId) {
              const tag = isPassExpectTime(item.classTimeBegin, 30);
              tag ? item.signState = 1 : item.signState = 0;
            }
            // item.isShowEditBtn = this.changeIsShowEditBtn(item);
            item.sort = index + 1;
            return item;
          });
          this.pageInfo.total = Number(res.message.total);
          // this.studentSts = +res.message.studentSts;
        } else {
          this.attendanceDetailsData = [];
          this.pageInfo.total = 0;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingAttendanceDetailsData = false;
      }
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getAttendanceDetailsList();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getAttendanceDetailsList();
    },
    // 获取要搜索的入参
    handleGetSearch(searchValue) {
      this.pageInfo.pageNum = 1;
      this.searchData = searchValue;
      this.getAttendanceDetailsList();
    },
    // 重置搜索
    initSearch(pageNum = 1) {
      this.pageInfo.pageNum = pageNum;
      this.getAttendanceDetailsList();
    },

    // 取消导出
    handleCancelDownLoad() {
      if (this.source) {
        this.source.cancel('取消导出'); // 这里传递的什么字符串，在上面的rej.message值就是什么
        // this.uploadPersent = 0;
        // this.canUploadFile = true;
        // this.modalShow = false;
        // this.uploadType === '';
      }
    },
    // 导出进度条模态框提示
    percentShowFun() {
      this.downLoadPersent += 20;
      if (this.downLoadPersent >= 80) {
        clearInterval(this.percentInterVal);
      }
    },
    percentShow() {
      this.downLoadPersent = 0;
      this.percentInterVal = setInterval(this.percentShowFun, 500);
    },
    // 导出-确定
    async handleExSubmit() {
      const params = {
        pageNum: 1,
        pageSize: this.pageInfo.total,
        stuId: this.stuId,
        classroomId: this.classroomId,
        payOrderId: this.payOrderId
      };
      const paramsData = Object.assign({}, this.searchData, params);
      this.percentModalShow = true;
      this.percentShow();
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();
      const onDownloadProgress = progressEvent => {
        if (progressEvent.lengthComputable) {
          const val = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);
          this.downLoadPersent = parseInt(val);
        }
      };
      const res = await eduCenter.getStudentAttendanceDetailsExcelApi(
        paramsData,
        this.source.token,
        onDownloadProgress
      );
      if (res) {
        const reader = new FileReader();
        let resData = null;
        reader.readAsText(res.data, 'utf-8');
        reader.onload = () => {
          if (res.data.type === 'application/vnd.ms-excel') {
            this.$Message.success('导出成功');
            clearInterval(this.percentInterVal);
            this.downLoadPersent = 100;
            setTimeout(() => {
              this.percentModalShow = false;
              this.showSelectExportModal = false;
            }, 500);
            downLoadByBlob(res);
          } else {
            resData = JSON.parse(reader.result);
            clearInterval(this.percentInterVal);
            this.downLoadPersent = 100;
            setTimeout(() => {
              this.percentModalShow = false;
              this.showSelectExportModal = false;
            }, 500);
            this.$Message.error(resData.error);
          }
        };
      } else {
        this.percentModalShow = false;
      }
    },
    // 是否可以展示修改按钮
    // changeIsShowEditBtn(row) {
    //   if (row.notChange === 1) {
    //     return false;
    //   }
    //   if (+row.signState >= 6) {
    //     return false;
    //   }
    //   // 已全部退款的不能修改签到状态
    //   if (row.signState !== 4 && row.tallySts === 5) {
    //     return false;
    //   }
    //   return true;
    // },
    // handleEdit(row) {
    //   if (row.classroomId === this.classroomId) {
    //     this.handleChangeSignState(row);
    //   } else {
    //     // 不同班的修改签到状态
    //     this.handleShowNewModal(row);
    //   }
    // },
    // handleShowNewModal(row, type = 'edit') {
    //   this.selectBtnType = type;
    //   // 不同班的修改签到状态
    //   this.selectRow = row;
    //   this.dealStatus(+row.signState, 'oldSubmitInfo');
    //   this.getCanEditList(row.signId, row.classroomId);
    //   this.changeDifferentModalShow = true;
    // },
    // 学生考勤-明细-查询未上课节次（pc）
    // async getCanEditList(signId, classroomId) {
    //   this.oldSubmitInfo.classroomId = this.selectBtnType === 'new' ? this.classroomId : classroomId;
    //   const params = {
    //     stuId: this.stuId, // 学生id
    //     payOrderId: this.payOrderId, // 订单号id
    //     signId// 考勤id
    //   };
    //   const res = await eduCenter.listSchStuSignClasstApi(params);
    //   if (res.status === 200) {
    //     this.listSchStuSignClassNo = res.message;
    //     this.selectClassroomIdIndex = this.listSchStuSignClassNo.findIndex(item => {
    //       return item.classroomId === this.oldSubmitInfo.classroomId;
    //     });
    //   }
    // },
    // getChangeClassroomId(value) {
    //   this.selectClassroomIdIndex = this.listSchStuSignClassNo.findIndex(item => {
    //     return item.classroomId === value;
    //   });
    // },
    // handleSureEdit() {
    //   if (this.oldSubmitInfo.classroomId !== this.classroomId && !this.judgeStatusCanChange(this.selectRow.signState, 'oldSubmitInfo')) {
    //     return;
    //   }
    //   this.editOldStatus();
    // },
    // async editOldStatus() {
    //   let signState = -1;
    //   switch (this.oldSubmitInfo.changeType) {
    //     case 1:
    //       signState = 2;
    //       break;
    //     case 2:
    //       signState = 3;
    //       break;
    //     case 3:
    //       signState = 1;
    //       break;
    //   }
    //   this.loadingChangeData = true;
    //   try {
    //     const params = {
    //       signId: this.selectRow.signId, // 考勤id
    //       stuId: this.stuId, // 学生id
    //       signState, // 1未考勤 2已签到 3请假
    //       classroomId: this.oldSubmitInfo.classroomId // 课班id
    //     };
    //     this.oldSubmitInfo.classroomId === this.classroomId ? params.detailId = this.oldSubmitInfo.detailId : '';
    //     let res = null;
    //     if (this.selectBtnType === 'new') {
    //       res = await eduCenter.addStuAttendanceStatusApi(params);
    //     } else {
    //       res = await eduCenter.updateOldClassSignStateApi(params);
    //     }
    //     // const res = await eduCenter.updateOldClassSignStateApi(params);
    //     if (res.status === 200) {
    //       this.$Message.success('修改成功');
    //       this.getAttendanceDetailsList();
    //       this.changeDifferentModalShow = false;
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   } finally {
    //     this.loadingChangeData = false;
    //   }
    // },
    // 修改签到状态
    // handleChangeSignState(row) {
    //   this.selectRow = row;
    //   this.dealStatus(+row.signState);
    //   this.changeSignStatusModalShow = true;
    // },
    // dealStatus(status, key = 'submitInfo') {
    //   switch (status) {
    //     case 0:
    //     case 1:
    //     case 5:
    //       this[key].changeType = 3; // 未签到
    //       break;
    //     case 2:
    //       this[key].changeType = 1; // 已签到
    //       break;
    //     case 3:
    //       this[key].changeType = 3;// 未签到
    //       break;
    //   }
    // },
    // actionValueStr(key) {
    //   let str = '';
    //   switch (Number(this[key].changeType)) {
    //     case 1:
    //       str = '修改为已签到';
    //       break;
    //     case 2:
    //       str = '修改为请假';
    //       break;
    //     case 3:
    //       str = '修改为未签到';
    //       break;
    //     case 4:
    //       str = '修改为请假（可退款）';
    //       break;
    //     default:
    //       break;
    //   }
    //   return str;
    // },
    // 判断当前状态是否能修改成别的状态
    // judgeStatusCanChange(status, key = 'submitInfo') {
    //   // status 0未开始1未考勤2签到3签退4请假5缺席6停课
    //   // actionValue 1:改为已签到 2:改为已请假 3:改为未签到 4:改为已请假(可退款)
    //   // （备注）actionValue 2、4的判断条件一致
    //   const actionValue = this[key].changeType;
    //   let clickStatus = false;
    //   switch (Number(status)) {
    //     // 未开始的考勤状态 (未开始可以去请假)
    //     case 0:
    //       clickStatus = actionValue === 2 || actionValue === 4;
    //       break;
    //     // 未签到的考勤状态 （未签到可以去 签到、请假、或者标记为缺勤）
    //     case 1:
    //       clickStatus =
    //         actionValue === 1 ||
    //         actionValue === 2 ||
    //         actionValue === 4 || actionValue === 5;
    //       break;
    //     // 签退的考勤状态
    //     case 3:
    //       clickStatus = actionValue === 1;
    //       break;
    //     // 已请假考勤状态
    //     case 2:
    //       clickStatus = actionValue === 3 || actionValue === 5;
    //       break;
    //     case 4:
    //       clickStatus = actionValue === 3;
    //       break;
    //     // 缺勤的考勤状态
    //     case 5:
    //       clickStatus =
    //        actionValue === 1 ||
    //         actionValue === 2 ||
    //        actionValue === 4;
    //       break;
    //   }
    //   if (!clickStatus) {
    //     this.$Message.error(`当前状态无法${this.actionValueStr(key)}`);
    //   }
    //   return clickStatus;
    // },
    // 点击确定按钮修改考勤状态
    // handleChangeSignStatus() {
    //   if (!this.judgeStatusCanChange(this.selectRow.signState)) {
    //     return;
    //   }
    //   this.editStatus();
    // },
    // 批量修改状态
    // async editStatus() {
    //   let signState = -1;
    //   switch (this.submitInfo.changeType) {
    //     case 1:
    //       signState = 2;
    //       break;
    //     case 2:
    //       signState = 3;
    //       break;
    //     case 3:
    //       signState = 1;
    //       break;
    //   }
    //   this.loadingChangeData = true;
    //   try {
    //     const params = {
    //       signId: this.selectRow.signId, // 考勤id
    //       stuId: this.stuId, // 学生id
    //       signState, // 1未考勤 2已签到 3请假
    //       classroomId: this.classroomId, // 课班id
    //       detailId: this.selectRow.detailId
    //     };
    //     // return console.log(params, '提交的修改数据----');
    //     // let res = null;
    //     // if (this.selectBtnType === 'new') {
    //     //   res = await eduCenter.addStuAttendanceStatusApi(params);
    //     // } else {
    //     //   res = await eduCenter.updateOldClassSignStateApi(params);
    //     // }
    //     const res = await eduCenter.updateOldClassSignStateApi(params);
    //     // const res = await eduCenter.updateOldClassSignStateApi(params);
    //     if (res.status === 200) {
    //       this.$Message.success('修改成功');
    //       this.getAttendanceDetailsList();
    //       this.changeSignStatusModalShow = false;
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   } finally {
    //     this.loadingChangeData = false;
    //   }
    // },
    // 打开操作记录弹窗
    handleOpenOperationModal() {
      this.operationPageInfo.pageNum = 1;
      this.operationSearchStr = '';
      this.getOperation();
      this.showOperationRecord = true;
    },
    // 获取操作记录
    async getOperation() {
      const params = {
        classroomId: this.classroomId,
        pageNum: this.operationPageInfo.pageNum,
        pageSize: this.operationPageInfo.pageSize,
        stuId: this.stuId
      };
      this.operationSearchStr ? params.keyword = this.operationSearchStr : '';
      this.loadingOperationData = true;
      const res = await eduCenter.getOperationListApi(params);
      this.loadingOperationData = false;
      if (res.status === 200) {
        this.operationListData = res.message.list;
        this.operationPageInfo.total = res.message.total;
      }
    },
    // 搜索操作记录
    handleSearchOperationRecord() {
      console.log(this.operationSearchStr, '关键词');
      this.operationPageInfo.pageNum = 1;
      this.getOperation();
    },
    handleOperationPageChange(page) {
      this.operationPageInfo.pageNum = page;
      this.getOperation();
    }
  }
};
</script>
<style lang="scss" scoped>
.class-search-box {
  background: rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  padding: 16px;
}
.askleave-table {
  /deep/.ivu-table-wrapper {
    overflow: visible;
  }
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
.time-line-courselist {
  line-height: 24px;
  padding: 8px 0;
}
.cancel-box {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
.baseinfo-box {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dcdee2;
  margin-top: 16px;
  margin-bottom: 24px;
}
.baseinfo-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(0, 0, 0, 0.03);
  padding: 16px 24px;
  .base-left {
    display: flex;
    align-items: center;
    .base-name {
      font-weight: bold;
      font-size: 14px;
    }
    span + span {
      margin-left: 8px;
    }
  }
  .base-right {
    display: flex;
    align-items: center;
  }
}
.baseinfo-content {
  padding-top: 24px;
}

.operation-search {
  margin-bottom: 24px;
  button {
    margin-left: 8px;
  }
}
</style>
